// Per-axis population min/max within a position template — the shared "all players by
// template" scaling every radar marker, tooltip and table row is drawn against (the read
// Phase 02c deferred out of useRadarData). Returned as a key→range map, memoised over the
// snapshot population + the axis list; the population scan is the expensive part, so it never
// re-runs unless the template or axes change. Built on the 04h-4a pure layer.

import { useMemo } from "react";
import { readSnapshot } from "../data/snapshot.js";
import { radarRange, type RadarAxis, type RadarRange } from "../modules/radar-view.js";
import type { RawPlayerRecord } from "../data/snapshot.js";

export function useRadarRanges(template: string, axes: readonly RadarAxis[]): Map<string, RadarRange> {
  return useMemo(() => {
    const population = Object.values(readSnapshot().players) as RawPlayerRecord[];
    const map = new Map<string, RadarRange>();
    for (const a of axes) map.set(a.key, radarRange(population, template, a.key));
    return map;
  }, [template, axes]);
}
